export enum SHIPPING_PROVIDER {
  FLASH = 'flash',
  JNT = 'jnt',
  THAIPOST = 'thaiPost',
  NINJA = 'ninja',
  BESTEXPRESS = 'bestExpress',
  KERRY = 'kerry',
  SPXEXPRESS = 'spx',
}

export const SHIPPING_PROVIDER_TEXT = {
  [SHIPPING_PROVIDER.FLASH as string]: 'Flash Express',
  [SHIPPING_PROVIDER.JNT as string]: 'J&T Express',
  [SHIPPING_PROVIDER.THAIPOST]: 'ไปรษณีย์ไทย',
  [SHIPPING_PROVIDER.NINJA as string]: 'Ninja Van',
  [SHIPPING_PROVIDER.BESTEXPRESS as string]: 'Best Express',
  [SHIPPING_PROVIDER.KERRY as string]: 'Kerry Express',
  [SHIPPING_PROVIDER.SPXEXPRESS as string]: 'SPX Express',
}

export const FLASH_STATUS_TEXT = [
  { code: 1, name: 'รับพัสดุแล้ว', status: 'pickedUp' },
  { code: 2, name: 'ระหว่างการขนส่ง', status: 'inTransit' },
  { code: 3, name: 'ระหว่างการจัดส่ง', status: 'delivering' },
  { code: 4, name: 'พัสดุคงคลัง', status: 'detained' },
  { code: 5, name: 'เซ็นรับแล้ว', status: 'signed' },
  { code: 6, name: 'ระหว่างจัดการพัสดุมีปัญหา', status: 'problem' },
  { code: 7, name: 'พัสดุตีกลับแล้ว', status: 'returned' },
  { code: 8, name: 'ปิดงานมีปัญหา', status: 'exception' },
  { code: 9, name: 'เรียกคืนพัสดุแล้ว', status: 'cancelled' },
]

export const JNT_STATUS_TEXT = [
  { code: 'Pickup', name: 'รับพัสดุแล้ว', status: 'Pickup' },
  { code: 'Departure', name: 'จัดสั่งพัสดุ', status: 'Departure' },
  { code: 'Arrival', name: 'มาถึง', status: 'Arrival' },
  { code: 'On Delivery', name: 'นำจ่ายพัสดุ', status: 'On Delivery' },
  {
    code: 'Salf Collection',
    name: 'รับพัสดุด้วยตนเอง',
    status: 'Salf Collection',
  },
  { code: 'Signature', name: 'เซ็นรับพัสดุ', status: 'Signature' },
  { code: 'Return', name: 'ตีกลับพัสดุ', status: 'Return' },
  {
    code: 'Return Confirmation',
    name: 'ยืนยันตีกลับพัสดุ',
    status: 'Return Confirmation',
  },
  {
    code: 'Return Signature',
    name: 'เซ็นรับพัสดุตีกลับ',
    status: 'Return Signature',
  },
  { code: 'Problematic', name: 'พัสดุมีปัญหา', status: 'Problematic' },
  { code: 'Storage', name: 'พัสดุตกค้าง', status: 'Storage' },
  { code: 'createOrder', name: 'สร้าง ORDER', status: 'createOrder' },
]

export const THAIPOST_STATUS_TEXT = [
  { code: 101, name: 'เตรียมการฝากส่ง', status: 'Pickup' },
  { code: 102, name: 'รับฝากผ่านตัวแทน', status: 'Agentdeposit' },
  { code: 103, name: 'รับฝาก', status: 'Deposit' },
  { code: 104, name: 'ผู้ฝากส่งขอถอนคืน / ยกเลิกการรับฝาก', status: 'Cancel' },
  { code: 201, name: 'อยู่ระหว่างการขนส่ง', status: 'Delivering' },
  { code: 202, name: 'ดำเนินพิธีการศุลกากร', status: 'Intransitintcustoms' },
  { code: 203, name: 'ส่งคืนต้นทาง', status: 'Return' },
  {
    code: 204,
    name: 'ถึงที่ทำการแลกเปลี่ยนระหว่างประเทศขาออก',
    status: 'Intransitintborder',
  },
  {
    code: 205,
    name: 'ถึงที่ทำการแลกเปลี่ยนระหว่างประเทศขาเข้า',
    status: 'Arrivetransitintborder',
  },
  { code: 206, name: 'ถึงที่ทำการไปรษณีย์', status: 'Arriveoffice' },
  {
    code: 208,
    name: 'ส่งออกจากที่ทำการแลกเปลี่ยนระหว่างประเทศขาออก',
    status: 'Outtransitintborder',
  },
  { code: 209, name: 'ยกเลิกการส่งออก', status: 'Cancelout' },
  { code: 210, name: 'ยกเลิกการนำเข้า', status: 'Cancelin' },
  { code: 211, name: 'รับเข้า ณ ศูนย์คัดแยก', status: 'Readytocollect' },
  { code: 212, name: 'ส่งมอบให้สายการบิน', status: 'Airplane' },
  { code: 213, name: 'สายการบินรับมอบ', status: 'Inairplane' },
  { code: 301, name: 'อยู่ระหว่างการนำจ่าย', status: 'Delivery' },
  {
    code: 302,
    name: 'อยู่ระหว่างการนำจ่ายนำจ่าย ณ จุดรับสิ่งของ',
    status: 'Indelivery',
  },
  { code: 401, name: 'นำจ่ายไม่สำเร็จ', status: 'Unsuccessdelivery' },
  { code: 501, name: 'นำจ่ายสำเร็จ', status: 'Successdelivery' },
  { code: 901, name: 'โอนเงินให้ผู้ขายเรียบร้อยแล้ว', status: 'Payment' },
]

export const KERRY_STATUS_TEXT = [
  { code: 'PickedUp', name: 'รับพัสดุแล้ว', status: 'PickedUp' },
  { code: 'Received', name: 'ผู้ส่งนำส่งที่สาขา', status: 'Received' },
  {
    code: 'CourierPickedUp',
    name: 'รับพัสดุโดย Courier',
    status: 'CourierPickedUp',
  },
  { code: 'Prepared', name: 'เตรียมนำส่ง', status: 'Prepared' },
  { code: 'Delivering', name: 'จัดส่งพัสดุ', status: 'Delivering' },
  {
    code: 'PendingReDelivering',
    name: 'รอส่งใหม่อีกครั้ง',
    status: 'PendingReDelivering',
  },
  { code: 'NewAddress', name: 'ส่งไปยังที่อยู่ใหม่', status: 'NewAddress' },
  { code: 'Returning', name: 'กำลังตีกลับไปต้นทาง', status: 'Returning' },
  {
    code: 'ArrivedDelivering',
    name: 'ถึงสถานีปลายทาง',
    status: 'ArrivedDelivering',
  },
  {
    code: 'SuccessReturned',
    name: 'ตีกลับพัสดุต้นทาง',
    status: 'SuccessReturned',
  },
  {
    code: 'InTransitInt',
    name: 'เตรียมขนส่งระหว่างประเทศ',
    status: 'InTransitInt',
  },
  {
    code: 'InTransitIntBorder',
    name: 'ระหว่างขนส่งระหว่างประเทศ',
    status: 'InTransitIntBorder',
  },
  {
    code: 'InTransitIntCustoms',
    name: 'ดำเนินเรื่องศุลกากร',
    status: 'InTransitIntCustoms',
  },
  {
    code: 'ReadyToCollect',
    name: 'ถึงจุดรับพัศดุแล้ว',
    status: 'ReadyToCollect',
  },
  { code: 'InTransit', name: 'กำลังจัดส่ง', status: 'InTransit' },
  {
    code: 'UnSuccessDelivering',
    name: 'จัดส่งไม่สำเร็จ',
    status: 'UnSuccessDelivering',
  },
  {
    code: 'ClosedDelivering',
    name: 'ปิดการจัดส่งเมื่อมาถึง',
    status: 'ClosedDelivering',
  },
  {
    code: 17,
    name: 'Awaiting consignee collection',
    status: 'AwaitConsigneeDelivering',
  },
  { code: 18, name: 'Customer moved', status: 'CustomerMoved' },
  { code: 19, name: 'ปลายทางรับพัสดุบางส่วน', status: 'PartiallyDelivering' },
  { code: 11, name: 'จัดส่งสำเร็จ', status: 'SuccessDelivered' },
]

export const BESTEXPRESS_STATUS_TEXT = [
  { code: 1, name: 'รับสินค้า', status: 'pickup_success' },
  { code: 2, name: 'รับสินค้าไม่สำเร็จ', status: 'pickup_failure' },
  { code: 3, name: 'ถึงสถานี', status: 'arrive_station' },
  { code: 4, name: 'ออกจากสถานี', status: 'send_from_station' },
  { code: 5, name: 'ถึง HUB', status: 'arrive_hub' },
  { code: 6, name: 'ออกจาก HUB', status: 'send_from_hub' },
  { code: 7, name: 'นำส่งสินค้า', status: 'out_for_delivery' },
  { code: 8, name: 'ส่งสินค้าสำเร็จ', status: 'delivered' },
  { code: 9, name: 'คืนสินค้า', status: 'package_return' },
  { code: 10, name: 'คืนสินค้าสำเร็จ', status: 'return_success' },
  { code: 11, name: 'ค้างส่ง (ที่สถานี)', status: 'hold_in_station' },
  { code: 12, name: 'ชำระค่าสินค้าแล้ว', status: 'payment_success' },
]

export const SPXEXPRESS_STATUS_TEXT = [
  { code: 1001, name: 'รอรับพัสดุ', status: 'pickup' },
  { code: 2001, name: 'พัสดุถูกจัดเก็บหรือส่งมอบแล้ว', status: 'transit' },
  { code: 3001, name: 'ถูกระงับ', status: 'hold' },
  { code: 4001, name: 'จัดส่งแล้ว', status: 'delivered' },
  { code: 5001, name: 'รับพัสดุไม่สำเร็จ', status: 'pickupFails' },
  { code: 5002, name: 'พัสดุได้รับความเสียหาย', status: 'damaged' },
  { code: 5003, name: 'พัสดุสูญหาย', status: 'lost' },
  { code: 6001, name: 'พัสดุกำลังตีกลับ', status: 'returning' },
  { code: 6002, name: 'พัสดุตีกลับไม่สำเร็จ', status: 'returnFails' },
  { code: 6003, name: 'พัสดุตีกลับสำเร็จ', status: 'returned' },
  { code: 7001, name: 'ยกเลิก', status: 'cancelled' },
]

export const SHIPPING_STATUS = [
  { provider: SHIPPING_PROVIDER.FLASH, status: FLASH_STATUS_TEXT },
  { provider: SHIPPING_PROVIDER.JNT, status: JNT_STATUS_TEXT },
  { provider: SHIPPING_PROVIDER.THAIPOST, status: THAIPOST_STATUS_TEXT },
  { provider: SHIPPING_PROVIDER.NINJA, status: [] },
  {
    provider: SHIPPING_PROVIDER.BESTEXPRESS,
    status: BESTEXPRESS_STATUS_TEXT,
  },
  { provider: SHIPPING_PROVIDER.KERRY, status: KERRY_STATUS_TEXT },
  { provider: SHIPPING_PROVIDER.SPXEXPRESS, status: SPXEXPRESS_STATUS_TEXT },
]
